export const reservations = (state) => state.reservations
export const getRestaurantReservations = (state) => state.reservations
export const getRestaurantReservation = (state) => (id) => state.reservations.find(x => x.id === id) || {}